import { Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { ReasonRejectionService } from '../../master/reason-for-rejection/reason-rejection.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import ReasonRejectionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/reason-rejection/reason-rejection.entity';
import { OrderDetailAttributes } from '@albatrosdeveloper/ave-models-package';

@Component({
  selector: 'app-form-reject',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatIconModule,
    FormsModule,
  ],
  templateUrl: './form-reject.component.html',
  styleUrl: './form-reject.component.scss'
})
export class FormRejectComponent {
  isLoading: boolean = false;

  reasonRejectionControl = new FormControl(null, Validators.required);
  reasonRejectionRequired: boolean = true;
  reasonRejectionDisabled: boolean = false;
  reasonRejectionList: ReasonRejectionAttributes[] = [];
  filteredReasonRejectionList = this.reasonRejectionList;
  searchReasonRejection: string = null;

  @ViewChild("orderConfirmationDialog")orderConfirmationDialog!: TemplateRef<any>;

  constructor(
    private readonly reasonRejectionService: ReasonRejectionService,
    public readonly dialogRef: MatDialogRef<FormRejectComponent>,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      type: string;
      orderDetail: OrderDetailAttributes;
    }
  ) {
  }

  ngAfterViewInit(): void {
    this.fetchReasonRejections();
  }

  fetchReasonRejections() {
    this.reasonRejectionService.findToComboBox(this.data.type).subscribe({
      next: (res) => {
        this.reasonRejectionList = res.data;
        this.filteredReasonRejectionList = this.reasonRejectionList;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener los motivos de cancelación.",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  filterReasonRejections() {
    const filterValue = this.searchReasonRejection.toLowerCase();
    this.filteredReasonRejectionList = this.reasonRejectionList.filter((e) =>
      e.name.toLowerCase().includes(filterValue)
    );
  }

  openConfirmationDialog(): void {
    this.dialog
      .open(this.orderConfirmationDialog, {
        data: {
          title: this.data.orderDetail ? 'Confirmar material' : 'Confirmar materiales', 
          message: this.data.orderDetail ? '¿Está seguro que desea rechazar el material?' : '¿Está seguro que desea rechazar los materiales?',
        },
        panelClass: "form-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.onSave());
  }

  onSave(): void {
    this.isLoading = true;
    const dataToUpdate = {
      reasonRejectionId: this.reasonRejectionControl.value,
    }

    this.isLoading = false;
    this.dialogRef.close(dataToUpdate);
  }
}
